import React, { useCallback } from 'react';
import { Select } from 'src/@vymo/ui/atoms';
import { RangePicker } from 'src/@vymo/ui/blocks/dateTime';
import { endOfDay, getTime } from 'date-fns';
// eslint-disable-next-line vymo-ui/restrict-import
import { DATE_FORMATS } from 'src/models/clientConfig/constants';
// eslint-disable-next-line vymo-ui/restrict-import
import { parseDateFormatToDateFns } from 'src/models/clientConfig/queries';
import { FormContextProps } from '../../formProvider/types';
import { rangeOptions } from './constants';
import { DateRangeV2Props } from './types';
import styles from './index.module.scss';

function DateRangePickerAdapter({
  value = {},
  onChange,
  loading,
  i18nConfig,
  viewMode = false,
  version,
  options,
  ...field
}: DateRangeV2Props &
  FormContextProps & { version: FormContextProps['config']['version'] }) {
  const format = parseDateFormatToDateFns(
    i18nConfig?.client_date_time_config?.[
      DATE_FORMATS.MEETING_DATE_NOT_IN_CURRENT_YEAR
    ]?.dateTimeFormat,
  );

  const startDate = value.start ? new Date(value.start) : null;
  const endDate = value.end ? new Date(value.end) : null;

  const onDateRangePickerChange = useCallback(
    (selectedDate, event) => {
      const [start, end] = selectedDate ?? [];

      const changeValue = {
        start: start ? new Date(start).getTime() : null,
        end: end ? endOfDay(new Date(end)).getTime() : null,
        type: 'custom',
      };

      if (field.isDebug) {
        // eslint-disable-next-line no-console
        console.log({
          'Selected Value': selectedDate,
          'On Change Value': changeValue,
        });
      }
      onChange(changeValue, event);
    },
    [field.isDebug, onChange],
  );

  const onChangeSelect = useCallback(
    (selectedValue, event) => {
      const selectedType = selectedValue?.[0]?.value;

      const changeValue = { start: null, end: null, type: selectedType };

      if (field.isDebug) {
        // eslint-disable-next-line no-console
        console.log({
          'Selected Value': selectedType,
          'On Change Value': changeValue,
        });
      }
      onChange(changeValue, event);
    },
    [field.isDebug, onChange],
  );

  return (
    <div className={styles.dateRangePickerContainer}>
      <Select
        value={value.type}
        options={options || rangeOptions}
        onChange={onChangeSelect}
      />
      {value.type === 'custom' && (
        <RangePicker
          value={[startDate, endDate]}
          onChange={onDateRangePickerChange}
          format={format}
          min={startDate ? getTime(startDate) : undefined}
          max={endDate ? getTime(endDate) : undefined}
          viewMode={viewMode}
          {...field}
        />
      )}
    </div>
  );
}

export default DateRangePickerAdapter;
